import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const temaComunicacionImporterSelectors = importerSelectors(
  'temaComunicacion.importer',
);

export default temaComunicacionImporterSelectors;
